const CYBERINT_CUSTOMER = 'cyberint_customer';
const CYBERINT_MANAGEMENT = 'cyberint_management';
const CYBERINT_PROVISIONING = 'cyberint_provisioning';
const MSSP_STANDALONE_ALLOCATION = 'mssp_standalone_allocated';
const MSSP_PARENT_ALLOCATION = 'mssp_parent_allocated';
const MSSP_MANAGEMENT = 'mssp_management';
const MSSP_PROVISIONING = 'mssp_provisioning';
const MSSP_REPORT = 'mssp_report';
const MULTI_TENANT_MANAGEMENT = 'multi_tenant_management';
const PARTNERS_VAR_MANAGEMENT = 'partners_var_management';
const PARTNERS_VAR_PROVISIONING = 'partners_var_provisioning';
// TEM_ESSENTIALS are FE-only, they not persist on the backend
const TEM_ESSENTIALS_PROVISIONING = 'tem_essentials_provisioning';
const TEM_ESSENTIALS_PRODUCTION = 'tem_essentials_production';

export const TENANT_TYPES = {
  CYBERINT_CUSTOMER,
  CYBERINT_MANAGEMENT,
  CYBERINT_PROVISIONING,
  MSSP_STANDALONE_ALLOCATION,
  MSSP_PARENT_ALLOCATION,
  MSSP_MANAGEMENT,
  MSSP_PROVISIONING,
  MSSP_REPORT,
  MULTI_TENANT_MANAGEMENT,
  PARTNERS_VAR_MANAGEMENT,
  PARTNERS_VAR_PROVISIONING,
  // TEM_ESSENTIALS are FE-only, they not persist on the backend
  TEM_ESSENTIALS_PROVISIONING,
  TEM_ESSENTIALS_PRODUCTION
};

const MANAGED_SERVICE = 'managed_service';
const MSSP_MANAGED_SERVICE = 'mssp_managed_service';
const MSSP = 'mssp';
const SELF_SERVICE = 'self_service';
const HYBRID_SERVICE = 'hybrid_service';

export const TENANT_ENVIRONMENTS = {
  MANAGED_SERVICE,
  MSSP_MANAGED_SERVICE,
  MSSP,
  SELF_SERVICE,
  HYBRID_SERVICE
};
